export default __webpack_public_path__ + "static/media/twitter.e2e893e5.svg";